import { render, staticRenderFns } from "./s-ar.vue?vue&type=template&id=09063f1d&scoped=true&"
import script from "./s-ar.vue?vue&type=script&lang=js&"
export * from "./s-ar.vue?vue&type=script&lang=js&"
import style0 from "./s-ar.vue?vue&type=style&index=0&id=09063f1d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09063f1d",
  null
  
)

export default component.exports